import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';
import { TableSkeleton } from '@/components/ui/skeleton';

const OrdersPage = lazy(() => import('@/pages/orders'));

/**
 * `?order=<id>` opens the XL detail modal over the orders index. Deep
 * linking is the dominant share pattern (operators paste URLs to each
 * other), so the modal-open state lives in the URL — not React state.
 *
 * `?modal=new` is reserved for the upcoming manual-order create dialog;
 * keep it in the validator so future wiring doesn't break this route.
 */
const SearchSchema = z.object({
  order: z.string().optional(),
  modal: z.enum(['new']).optional(),
});

export const Route = createFileRoute('/orders')({
  validateSearch: (search) => SearchSchema.parse(search),
  component: function OrdersRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <OrdersPage />
      </Suspense>
    );
  },
});
